module.exports = __webpack_public_path__ + "img/camera.3836a2ce.svg";